<template>
  <a-layout-header
    :style="{
      background: '#fff',
      padding: 0,
      boxShadow: '4px 0px 4px #f60',
      height: '80px',
    }"
  >
    <div
      v-on:mousedown="mouseDownHandler($event)"
      style="width: 100%; height: 100%"
    >
      <div class="tool">
        <Admin
          v-if="
            $store.state.user.userinfo &&
            $store.state.user.userinfo.role_id == -1
          "
        />
        <div class="flex">
          <a-avatar
            size="large"
            v-if="$store.state.user.userinfo.project.logo"
            :src="$store.state.user.userinfo.project.logo"
          />
          <a-avatar
            size="large"
            v-else
            :style="{ backgroundColor: '#87d068' }"
            icon="user"
          />
          <div class="username">
            {{
              !!$store.state.user.userinfo.project.name
                ? $store.state.user.userinfo.project.name
                : $store.state.user.userinfo && $store.state.user.userinfo.id
                ? $store.state.user.userinfo.nickname
                  ? $store.state.user.userinfo.nickname
                  : $store.state.user.userinfo.username
                : ""
            }}
          </div>
        </div>
        <div class="divider">
          <a-divider type="vertical" />
        </div>
        <div class="quanping" @click="screenFull">
          <a-icon type="fullscreen" />
        </div>
        <div class="divider">
          <a-divider type="vertical" />
        </div>
        <div class="loginout" @click="loginout">退出</div>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
// const { ipcRenderer } = require("electron");
import Admin from "./admin.vue";
import router, { resetRouter } from "@/router";
export default {
  components: { Admin },
  data() {
    return {
      isDown: false,
      baseX: 0,
      baseY: 0,
      fullscreenStatus: false,
    };
  },
  // mounted() {
  //   var that = this;
  //   document.body.addEventListener("mousemove", function (e) {
  //     if (that.isDown) {
  //       const x = e.screenX - that.baseX;
  //       const y = e.screenY - that.baseY;
  //       ipcRenderer.send("move-application", {
  //         posX: x,
  //         posY: y,
  //       });
  //     }
  //   });
  //   document.body.addEventListener("mouseup", function (e) {
  //     that.isDown = false;
  //   });
  // },
  mounted() {
    document.addEventListener("fullscreenchange", (event) => {
      if (document.fullscreenElement) {
        console.log(
          `Element: ${document.fullscreenElement.id} entered full-screen mode.`
        );
      } else {
        console.log("Leaving full-screen mode.");
        this.fullscreenStatus = false
      }
    });
  },
  methods: {
    screenFull() {
      let element = document.getElementById("bodyContnet"); //设置后就是   让id==box的容器全屏
      // let element = document.documentElement //设置后就是   让id==box的容器全屏
      if (this.fullscreenStatus) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreenStatus = !this.fullscreenStatus;
    },
    mouseDownHandler(e) {
      this.isDown = true;
      this.baseX = e.x;
      this.baseY = e.y;
    },
    loginout() {
      this.$confirm({
        title: "提示",
        content: "是否退出当前账号",
        okText: "确认退出",
        cancelText: "取消",
        getContainer: () => document.getElementById("bodyContnet"),
        onOk: () => {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              this.$store.commit("setProjectId", "");
              this.$store.dispatch("Loginout", {
                router: router,
                resetRouter: resetRouter,
              });
              this.$message.success("退出登录成功");
              resolve();
            }, 1000);
          });
        },
        onCancel() {},
      });
    },
  },
};
</script>


<style scoped>
.tool {
  float: right;
  height: 100%;
  width: auto;
  padding: 0 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
}
.username {
  font-size: 14px;
  line-height: 20px;
  color: #585f6a;
  margin-left: 10px;
}
.divider {
  margin-left: 16px;
  margin-right: 16px;
}
.loginout {
  font-size: 14px;
  line-height: 20px;
  color: #212121;
  cursor: pointer;
}
.quanping {
  font-size: 20px;
  line-height: 20px;
  /* color: #1890ff; */
  cursor: pointer;
}
</style>